import { action } from 'satcheljs';
import type { ReadingPaneViewType } from 'owa-calendar-helpers-types/lib/ReadingPaneViewType';
import { ClientItemId } from 'owa-client-ids';

export const onShowReadingPane = action(
    'onShowReadingPane',
    (formId: string, viewType: ReadingPaneViewType) => ({
        formId,
        viewType,
    })
);

export const onReadingPaneLoaded = action(
    'onReadingPaneLoaded',
    (formId: string, viewType: ReadingPaneViewType, itemId: ClientItemId, iCalUId?: string) => ({
        formId,
        viewType,
        itemId,
        iCalUId,
    })
);

export const onHideReadingPane = action(
    'onHideReadingPane',
    (formId: string, viewType: ReadingPaneViewType) => ({
        formId,
        viewType,
    })
);

/**
 * Action for native addins to listen to for when the reading pane closes
 */
export const onReadingPaneNativeAddinClose = action(
    'onReadingPaneNativeAddinClose',
    (formId: string, targetWindow?: Window) => ({
        formId,
        targetWindow,
    })
);
